export default __webpack_public_path__ + "static/media/import.c3037559.svg";